import dayjs from "dayjs";
import theme from "utils/themeVars";

const getTodosCountTransformer = response => {
    const updatedCounts = Object.entries(response?.dateWiseCounts).map(([date, counts]) => {
        const [day, month, year] = date?.split('-');
        const formattedMonth = dayjs(`${year}-${month}-${day}`).format('MMM');
        const total = counts?.meetings + counts?.calls + counts?.sales;
        return {
            date,
            day,
            month: formattedMonth,
            total,
            meetings: counts?.meetings,
            calls: counts?.calls,
            sales: counts?.sales,
            color: total <= 20 ? theme["primary-color"] : total <= 40 ? theme["warning-color"] : theme["error-color"]
        };
    });
    return {...response, dateWiseCounts: updatedCounts}
}

export default getTodosCountTransformer